import axios from "utils/axios";
import type { CustomAxiosRequestConfig } from "@xt/xtbase";

const URL = "/xt-message/";
// 更新通知语言
export function put_noticeLang(config?: CustomAxiosRequestConfig) {
  return axios.put(URL + `private/user-lang`, null, config);
}

// 获取通知语言
export function get_noticeLang(config?: CustomAxiosRequestConfig) {
  return axios.get(URL + `private/user-lang`, config);
}

//获取广告列表
export function getUserLetterList(config) {
  return axios.get(URL + `private/user-letter/list`, config);
}


//获取广告Group
export function getUserLetterGroup(config) {
  return axios.get(URL + `private/user-letter/group`, config);
}

// 全部已读
export function getUserLetterRead(config) {
  return axios.put(URL + `private/user-letter/read`, null, config);
}

// 市场营销设置
export function putUserNoticeConfig(config) {
  return axios.put(URL + `private/user-notice-config`, null, config);
}

export function getUserNoticeConfigList(config) {
  return axios.get(URL + `private/user-notice-config/list`, config);
}



